import { useCallback, memo } from 'react';
import { ShipmentStopsGridData } from '@pages/reporting-pages/shipment-stops/types/ShipmentStopsGridData';
import { TimelineLimitTimes } from '@pages/reporting-pages/shipment-stops/types/TimelineLimitTimes';
import { HoursArrayElement } from '@pages/reporting-pages/shipment-stops/types/HoursArrayElement';
import TimelineRow from '@pages/reporting-pages/shipment-stops/grid-data/timeline-components/TimelineRow';
import useTimelineData from '@pages/reporting-pages/shipment-stops/grid-data/timeline-components/useTimelineData';



interface GridRowProps {
	item: ShipmentStopsGridData,
	rowIndex: number,
	hoursArray: HoursArrayElement[],
	limitTimes: TimelineLimitTimes,
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex, hoursArray, item, limitTimes } = props;
	const { customerSapId, customerName, city, street, salesMan, plannedTimes, realTimes, stopNumber } = props.item;

	const timelineData = useTimelineData(item, limitTimes);

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				<p>{customerSapId ? customerSapId : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{customerName ? customerName : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{city ? city : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{street ? street : '-'}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{salesMan ? salesMan : '-'}</p>
			</div>

			<div className={`${getClassName(true)} ${timelineData.colorStatus}`}>
				<p>{plannedTimes ? plannedTimes : '-'}</p>
			</div>

			<div className={`${getClassName(true)} ${timelineData.colorStatus}`}>
				<p>{realTimes ? realTimes : '-'}</p>
			</div>

			<div className='separator-cell'>
			</div>

			<TimelineRow
				hoursArray={hoursArray}
				className={getClassName(true)}
				timelineData={timelineData}
				stopNumber={stopNumber} />
		</>
	)
}

export default memo(GridRow);